import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import HomePage from './pages/HomePage';
import SobreNosPage from './pages/SobreNosPage';
import PortfolioPage from './pages/PortfolioPage';
import ContatosPage from './pages/ContatosPage';
import './App.css';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/sobre" element={<SobreNosPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contatos" element={<ContatosPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <AnimatedRoutes />
      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
